// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".20b05ce34d4d923feddf5a78adb71babc1f670da.chunk.bundle.js";
};